import styled from 'astroturf/react';

const CapboxProgressWrapper = styled('div')`
  display: flex;
  width: 100%;
  padding: 15px;
  border: 0.5px solid var(--ph-gray-250);
  margin-bottom: 20px;
`;

const CapboxProgressHeader = styled('div')`
  width: 100%;
`;

const CapboxProgressTitleDescription = styled('div')`
  font-size: var(--ph-text-md);
  font-family: var(--ph-font-family-lato-heavy);
  color: var(--dark-blue);
  float: left;
  width: 30%;
  @media screen and (max-width: 1200px) {
    width: 100%;
  }
`;

const CapboxProgressTitle = styled('h2')`
  font-size: var(--ph-text-md);
  font-family: var(--ph-font-family-lato-heavy);
  color: var(--dark-blue);
  float: left;
  width: 100%;
`;

const CapboxProgressDescriptionBoxWrapper = styled('div')`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

const CapboxProgressDescriptionBox = styled('div')`
    margin-right: auto;
    &:not(:first-child) {  
        padding-left: 10px;
        border-left: .5px solid var(--ph-gray-250);
    }
`;

const CapboxProgressDescription = styled('div')`
  font-size: 11px;
  font-family: var(--ph-font-family-source-sans-pro-semibold);
  color: var(--dark-blue);
`;

const CapboxProgressDescriptionCount = styled('div')`
  font-size: 21px;
  font-family: var(--ph-font-family-lato-bold);
  color: var(--dark-blue);
`;

const CapboxProgressBar = styled('div')`
  float: right;
  width: 70%;
  margin-top: 14px;
  @media screen and (max-width: 1200px) {
    width: 100%;
  }
`;

export default {
    CapboxProgressWrapper,
    CapboxProgressHeader,
    CapboxProgressTitleDescription,
    CapboxProgressTitle,
    CapboxProgressDescriptionBoxWrapper,
    CapboxProgressDescriptionBox,
    CapboxProgressDescription,
    CapboxProgressDescriptionCount,
    CapboxProgressBar,
};
